import React from "react";
import { Bar } from "react-chartjs-2";
import { trackPromise } from "react-promise-tracker";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme,
  Grid,
} from "@mui/material";

import axios from "axios";
import { useEffect, useState } from "react";

const SalesByDistricts = ({
  dayShow,
  weekShow,
  monthShow,
  threeMonthsShow,
  sixMonthsShow,
}) => {
  const theme = useTheme();
  const [result, setResult] = useState({ sales: { labels: [], datasets: [] } });
  const [percentage, setPercentage] = useState(
    new Array(3).fill({
      district1: 0,
      district2: 0,
      district5: 0,
      district22: 0,
      district23: 0,
      district24: 0,
      district25: 0,
      district26: 0,
    }),
  );

  useEffect(() => {
    trackPromise(
      axios
        .get(
          "http://192.168.14.53:8000/api/districtSales/periodic_districts_sales",
          {
            params: {
              daily: dayShow,
              weekly: weekShow,
              monthly: monthShow,
              threeMonths: threeMonthsShow,
              sixMonths: sixMonthsShow,
            },
          },
        )
        .then((res) => {
          setResult(res.data);
          setPercentage(res.data.percentage);
        }),
    );
  }, [weekShow, monthShow, threeMonthsShow, sixMonthsShow]);

  const [open, setOpen] = React.useState(true);

  const options = {
    animation: false,
    cutoutPercentage: 70,
    layout: { padding: 0 },
    legend: {
      display: true,
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  const DISTRICTS = [
    { key: "district1", label: "1" },
    { key: "district2", label: "2" },
    { key: "district5", label: "5" },
    { key: "district22", label: "22" },
    { key: "district23", label: "23" },
    { key: "district24", label: "24" },
    { key: "district25", label: "25" },
    { key: "district26", label: "26" },
  ];
  const COLORS = ["#0D830F", "#86086D", "#3a34eb"];

  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
      }}
    >
      <CardHeader
        title="Sales By Districts"
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
      ></CardHeader>

      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 500,
            position: "relative",
          }}
        >
          <Bar data={result.sales} options={options} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            pt: 2,
          }}
        >
          {DISTRICTS.map((district) => (
            <Box
              key={district.key}
              sx={{
                p: 1,
                textAlign: "center",
              }}
            >
              <Typography color="textPrimary" variant="body1">
                {district.label}
              </Typography>
              {percentage.map((yearData, index) => (
                <Typography
                  key={index}
                  style={{ color: COLORS[index] }}
                  variant="h4"
                >
                  {yearData[district.key]}%
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SalesByDistricts;
